import React from 'react';
import { Download, Moon, Sun, LogOut, LogIn } from 'lucide-react';
import './Header.css';
import { useTheme } from '../context/ThemeContext';

const Header = ({ showDownloadButton, onDownloadConversation, user, onSignOut, onSignIn }) => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="header-title">Talyora</h1>
        </div>
        <div className="header-right">
          {/* Download button */}
          <button 
            className="download-button"
            onClick={onDownloadConversation}
            disabled={!showDownloadButton}
            aria-label="Download conversation"
            data-tooltip="Download conversation"
          >
            <Download size={16} />
          </button>
          
          {/* Theme toggle */}
          <button 
            className="theme-toggle-button"
            onClick={toggleTheme}
            aria-label={isDarkMode ? 'Light mode' : 'Dark mode'}
            data-tooltip={isDarkMode ? 'Light mode' : 'Dark mode'}
          >
            {isDarkMode ? <Sun size={16} /> : <Moon size={16} />}
          </button>
          
          {/* Sign in button (when not authenticated) */}
          {!user && onSignIn && (
            <button 
              className="signin-button"
              onClick={onSignIn}
              aria-label="Sign in"
              data-tooltip="Sign in"
            >
              <LogIn size={16} />
            </button>
          )}
          
          {/* Sign out button (when authenticated) */}
          {user && onSignOut && (
            <button 
              className="signout-button"
              onClick={onSignOut}
              aria-label="Sign out"
              data-tooltip="Sign out"
            >
              <LogOut size={16} />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;